import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { JobProgressNotification } from 'src/app/shared/modals/job-follow-up/models/job-progress-notification';
import { SystemNotification, SystemNotificationPaged } from '../classes/notification';

@Injectable({ providedIn: 'root' })
export class NotificationService {


    constructor(private _httpService: BackendService,) {
    }

    public getNotifications(page: number = 1) {
        const parameters = [
            { 'name': 'Page', 'value': page as any },
        ];
        
        return this._httpService.get<SystemNotificationPaged>('getUserNotifications', [], parameters);
    }


    public markAsRead(id: number) {
        return this._httpService.put('userNotificationRead', { id });
    }


}
